module.exports = __webpack_public_path__ + "static/media/Contact.23742dc7.gif";